import BubbleCommon, {
  compareKeyMetricsEngagementRateTips,
  compareKeyMetricsEngagementTips,
  summaryKeyTopicTips,
  summaryMentionsRatioTips,
  summaryNegativeRatioTips,
  summaryNegativeTips,
  summaryPositiveTips,
} from '@/pages/opinion/components/BubbleCommon';
import { arrayToSimpleObj } from '@/pages/opinion/utils';
import { reviewsFormat, yAxleFormat } from '@/pages/opinion/utils/value';
import React from 'react';
import { IndicatorsType } from '../context';

export const indicatorsOptions = [
  { text: 'Mentions', value: 'mentions' },
  {
    text: 'Mentions%',
    value: 'mentions_ratio',
    tips: summaryMentionsRatioTips,
  },
  { text: 'Sentiment', value: 'sentiment' },
  {
    text: 'Negative%-2',
    value: 'negative_mentions',
    tips: summaryNegativeRatioTips,
  },
  {
    text: 'Engagement',
    value: 'engagement',
    tips: compareKeyMetricsEngagementTips,
  },
  {
    text: 'Engagement%-1',
    value: 'engagement_ratio',
    tips: compareKeyMetricsEngagementRateTips,
  },
];

export const topicTypeOptions = [
  { text: 'Key Topic', value: 'key_topic', tips: summaryKeyTopicTips },
  {
    text: 'All Topic',
    value: 'all_topic',
  },
];

export const sentimentOptions = (formatMessage: any) => [
  { text: formatMessage({ id: 'Total-2' }), value: 'total' },
  {
    text: (
      <BubbleCommon
        placement="top"
        showIcon={false}
        placementOffset={20}
        tipsMap={summaryPositiveTips}
      >
        {formatMessage({ id: 'AVG Positive' })}
      </BubbleCommon>
    ),
    value: 'positive',
  },
  {
    text: (
      <BubbleCommon
        placement="top"
        showIcon={false}
        placementOffset={20}
        tipsMap={summaryNegativeTips}
      >
        {formatMessage({ id: 'AVG Negative' })}
      </BubbleCommon>
    ),
    value: 'negative',
  },
];

export const topicTierOptions = (formatMessage: any) => [
  { text: formatMessage({ id: 'Tier 1 Topic' }), value: 'L1' },
  {
    text: formatMessage({ id: 'Tier 2 Topic' }),
    value: 'L2',
  },
];

export const sentimentOptionsMap: any = {
  total: 'Total',
  positive: 'AVG Positive',
  negative: 'AVG Negative',
};

export const indicatorsMap = arrayToSimpleObj(indicatorsOptions);

const rationValueFunc = (value: number) => {
  if (!value) {
    return '-';
  }
  if (value === 1) {
    return '100%';
  }
  return (value * 100)?.toFixed(2) + '%';
};

export const dealwithValueFuncMap: {
  [key in IndicatorsType]: (value: number) => string | number;
} = {
  mentions: (value: number) => reviewsFormat(value, 2, '0'),
  mentions_ratio: rationValueFunc,
  sentiment: (value: number) => (value === 0 ? '-' : value?.toFixed(2)),
  negative_mentions: rationValueFunc,
  positive_mentions: rationValueFunc,
  engagement: (value: number) => reviewsFormat(value),
  engagement_ratio: rationValueFunc,
};

export const dealwithEChartYFuncMap: any = {
  mentions: (value: number) => yAxleFormat(value),
  mentions_ratio: (value: number) =>
    Math.floor(Number((value * 10000).toFixed(6))) / 100 + '%',
  sentiment: (value: number) => value?.toFixed(0),
  positive_mentions: (value: number) =>
    Math.floor(Number((value * 10000).toFixed(6))) / 100 + '%',
  negative_mentions: (value: number) =>
    Math.floor(Number((value * 10000).toFixed(6))) / 100 + '%',
  engagement: (value: number) => yAxleFormat(value),
  engagement_ratio: (value: number) =>
    Math.floor(Number((value * 10000).toFixed(6))) / 100 + '%',
};

export const languageMap: any = {
  zh: 'Chinese',
  en: 'English',
};

export const sentimentMap: any = {
  positive: [5],
  neutral: [3],
  negative: [1],
  all: [5, 3, 1],
};

export const sourceMap: any = {
  game_store: 'Game Store',
  social: 'Social Media',
};

export const typeMap: any = {
  1: 'Topic Summary-1',
  2: 'Topic Trend',
  3: 'Specific Categories',
};

export const expandableLeftChartHeight = 178;
